<template>
  <div v-if="loadingPlans === false" class="hidden-sm-and-down">
    <v-navigation-drawer v-model="showSummaryNav" class="modern-drawer" width="320">
      <div class="pa-3">
        <v-row v-if="loadingPlans === false">
          <v-col cols="12">
            <v-btn class='modern-btn mb-2' @click="save" color="success" v-if="plan.team.id" variant="elevated"
                   style="width:100%">
              <v-icon class="me-2">mdi-content-save</v-icon>
              Save
            </v-btn>
            <v-btn class='modern-btn' @click="$router.go(-1)" variant="outlined" style="width:100%">
              <v-icon class="me-2">mdi-arrow-left</v-icon>
              Cancel
            </v-btn>
            <!--        <v-btn class='ma-1' color="error" @click="deletePracticePlan()"> Delete</v-btn>-->
          </v-col>
        </v-row>

        <v-card class="modern-card mb-3" elevation="1">
          <v-card-title class="card-header-compact">
            <v-icon class="me-2" color="primary" size="small">mdi-account-group</v-icon>
            Team & Details
          </v-card-title>
          <v-card-text class="pa-3">
            <v-select v-if="teams.length > 1 && plan.team" label="Team" v-model="plan.team" density="compact"
                      item-title="name"
                      item-value="name"
                      return-object :items="this.teams" variant="outlined" class="mb-2"></v-select>
            <h3 v-if="teams.length === 1" class="text-subtitle-1 mb-2">
              <v-icon class="me-2" color="success" size="small">mdi-account-group</v-icon>
              {{ plan.team.name }}
            </h3>
            <v-text-field label="Practice Title" v-model="plan.name" variant="outlined" density="compact"
                          class="mb-2"></v-text-field>
            <v-textarea label="Notes" auto-grow rows="1" v-model="plan.notes" variant="outlined" density="compact"
                        class="mb-2"></v-textarea>
            <VDatePicker title-position="left" mode="date" v-model="plan.date" borderless class="mb-2 compact-picker"/>
            <VDatePicker title-position="left" mode="time" v-model="plan.date" :rules="timeRules" hide-time-header
                         time-accuracy=2 borderless class="compact-picker"/>
          </v-card-text>
        </v-card>

        <v-card class="modern-card" elevation="1">
          <v-card-title class="card-header-compact">
            <v-icon class="me-2" color="info" size="small">mdi-chart-box</v-icon>
            Summary
          </v-card-title>
          <v-card-text class="pa-3">
            <v-table class="summary-table-compact">
              <tbody>
              <tr
                  v-for="(value, name) in summary"
                  :key="name"
                  class="summary-row-compact"
              >
                <td class="summary-label-compact">{{ name }}</td>
                <td class="summary-value-compact">{{ value }}m</td>
              </tr>
              </tbody>
            </v-table>
          </v-card-text>
        </v-card>
      </div>
    </v-navigation-drawer>
    <v-navigation-drawer location='left' v-model="showMobileNav" v-if="loadingPlans === false"
                         class="hidden-sm-and-down modern-drawer">
      <div class="pa-4">
        <v-card class="modern-card mb-4" elevation="1">
          <v-card-title class="card-header">
            <v-icon class="me-3" color="primary">mdi-clock-plus</v-icon>
            Time Slots
          </v-card-title>
          <v-card-text class="pa-4">
            <v-btn class='modern-btn mb-2' @click="addTimeSlot" color="primary" variant="elevated" style="width:100%">
              <v-icon class="me-2">mdi-plus</v-icon>
              Add Time Slot
            </v-btn>
            <v-btn class='modern-btn' @click="addWaterBreak" color="indigo" variant="elevated" style="width:100%">
              <v-icon class="me-2">mdi-cup-water</v-icon>
              Add Water Break
            </v-btn>
          </v-card-text>
        </v-card>

        <v-card class="modern-card" elevation="1">
          <v-card-text class="pa-0">
            <v-list lines="one" class="time-slot-list" v-sortable @end="onDrop">
              <v-list-item
                  v-for="(timeSlot, timeSlotIndex) in plan.timeSlots"
                  :key="timeSlot"
                  :class="{ 'break-slot': timeSlot.isBreak, 'selected-slot': timeSlot == selectedTimeSlot }"
                  :active="timeSlot == selectedTimeSlot"
                  @click="selectTimeslot(timeSlot, timeSlotIndex)"
                  class="time-slot-item"
              >
                <template v-slot:prepend>
                  <v-avatar :color="timeSlot.isBreak ? 'indigo' : 'primary'" size="32" class="me-3">
                    <v-icon color="white" size="small">
                      {{ timeSlot.isBreak ? 'mdi-cup-water' : 'mdi-clock' }}
                    </v-icon>
                  </v-avatar>
                </template>
                <v-list-item-title class="text-body-2 font-weight-medium">
                  <TimeDisplay :practiceStartTime="plan.date" :timeSlots="plan.timeSlots" :index="timeSlotIndex"
                               :duration="timeSlot.duration">
                  </TimeDisplay>
                </v-list-item-title>
                <v-list-item-subtitle class="text-caption">
                  <div v-if="timeSlot.isBreak" class="text-indigo">
                    Water Break
                  </div>
                  <DrillListSummary :drills="timeSlot.drills"/>
                </v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </div>
    </v-navigation-drawer>

  </div>
  <div v-if="loadingPlans === false" class="hidden-md-and-up mobile-view">
    <v-container class="pa-4">
      <v-card class="modern-card mb-4" elevation="2">
        <v-card-title class="card-header">
          <v-icon class="me-3" color="primary">mdi-phone</v-icon>
          Mobile Controls
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="6">
              <v-btn @click="save" color="success" v-if="plan.team.id" variant="elevated" style="width:100%">
                <v-icon class="me-2">mdi-content-save</v-icon>
                Save
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn @click="$router.go(-1)" variant="outlined" style="width:100%">
                <v-icon class="me-2">mdi-arrow-left</v-icon>
                Cancel
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12">
              <VDatePicker title-position="left" mode="dateTime" v-model="plan.date" borderless :rules="timeRules"/>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="6">
              <v-btn @click="addTimeSlot" color="primary" variant="elevated" style="width:100%">
                <v-icon class="me-2">mdi-plus</v-icon>
                Add Time Slot
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn @click="addWaterBreak" color="indigo" variant="elevated" style="width:100%">
                <v-icon class="me-2">mdi-cup-water</v-icon>
                Add Water Break
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="modern-card" elevation="2">
        <v-card-title class="card-header">
          <v-icon class="me-3" color="info">mdi-clock-outline</v-icon>
          Select Time Slot
        </v-card-title>
        <v-card-text class="pa-4">
          <v-menu style="width:100%;">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" variant="outlined" class="time-slot-selector" style="width:100%">
                <div v-if="selectedTimeSlot" class="d-flex align-center">
                  <v-avatar :color="selectedTimeSlot.isBreak ? 'indigo' : 'primary'" size="24" class="me-3">
                    <v-icon color="white" size="small">
                      {{ selectedTimeSlot.isBreak ? 'mdi-cup-water' : 'mdi-clock' }}
                    </v-icon>
                  </v-avatar>
                  <div class="text-left">
                    <div class="text-body-2 font-weight-medium">
                      <TimeDisplay :practiceStartTime="plan.date" :timeSlots="plan.timeSlots"
                                   :index="selectedTimeSlotIndex"
                                   :duration="selectedTimeSlot.duration">
                      </TimeDisplay>
                    </div>
                    <div v-if="selectedTimeSlot.isBreak" class="text-caption text-indigo">
                      Water Break
                    </div>
                    <div v-else class="text-caption">
                      <DrillListSummary :drills="selectedTimeSlot.drills"/>
                    </div>
                  </div>
                </div>
                <div v-if="!selectedTimeSlot" class="text-body-2">
                  <v-icon class="me-2">mdi-clock-plus</v-icon>
                  Select Time Slot
                </div>
              </v-btn>
            </template>

            <v-list class="time-slot-menu">
              <v-list-item
                  v-for="(timeSlot, timeSlotIndex) in plan.timeSlots"
                  :key="timeSlot"
                  @click="selectTimeslot(timeSlot, timeSlotIndex)"
                  class="time-slot-menu-item"
              >
                <template v-slot:prepend>
                  <v-avatar :color="timeSlot.isBreak ? 'indigo' : 'primary'" size="32" class="me-3">
                    <v-icon color="white" size="small">
                      {{ timeSlot.isBreak ? 'mdi-cup-water' : 'mdi-clock' }}
                    </v-icon>
                  </v-avatar>
                </template>
                <v-list-item-title class="text-body-2 font-weight-medium">
                  <TimeDisplay :practiceStartTime="plan.date" :timeSlots="plan.timeSlots" :index="timeSlotIndex"
                               :duration="timeSlot.duration">
                  </TimeDisplay>
                </v-list-item-title>
                <v-list-item-subtitle class="text-caption">
                  <div v-if="timeSlot.isBreak" class="text-indigo">
                    Water Break
                  </div>
                  <DrillListSummary :drills="timeSlot.drills"/>
                </v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-text>
      </v-card>
    </v-container>
  </div>


  <v-main class="practice-main">
    <v-container class="pa-6">
      <v-banner
          v-if="errorMessage"
          icon="mdi-alert-circle"
          color="error"
          class="modern-banner mb-4"
      >
        <template v-slot:text>
          {{ errorMessage }}
        </template>

        <template v-slot:actions>
          <v-btn @click="dismissError" variant="outlined">
            <v-icon class="me-2">mdi-close</v-icon>
            Dismiss
          </v-btn>
        </template>
      </v-banner>

      <v-progress-linear
          :active="loadingPlans"
          color="primary"
          height="3"
          indeterminate
          class="mb-4"
      ></v-progress-linear>

      <v-card v-if="selectedTimeSlot" class="modern-card mb-4" elevation="2">
        <v-card-title class="card-header">
          <v-icon class="me-3" :color="selectedTimeSlot.isBreak ? 'indigo' : 'primary'">
            {{ selectedTimeSlot.isBreak ? 'mdi-cup-water' : 'mdi-clock' }}
          </v-icon>
          {{ selectedTimeSlot.isBreak ? 'Water Break' : 'Time Slot' }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" md="8">
              <div class="d-flex align-center mb-3">
                <v-avatar :color="selectedTimeSlot.isBreak ? 'indigo' : 'primary'" size="40" class="me-3">
                  <v-icon color="white">
                    {{ selectedTimeSlot.isBreak ? 'mdi-cup-water' : 'mdi-clock' }}
                  </v-icon>
                </v-avatar>
                <div>
                  <div class="text-h6 font-weight-medium">
                    <TimeDisplay :practiceStartTime="plan.date" :timeSlots="plan.timeSlots"
                                 :index="selectedTimeSlotIndex"
                                 :duration="selectedTimeSlot.duration"/>
                  </div>
                  <div v-if="selectedTimeSlot.isBreak" class="text-body-2 text-indigo">
                    Water Break
                  </div>
                  <div v-else class="text-body-2 text-medium-emphasis">
                    Practice Time Slot
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                  type="number"
                  label="Duration (minutes)"
                  v-model="selectedTimeSlot.duration"
                  variant="outlined"
                  density="comfortable"
                  class="mb-3"
              ></v-text-field>
              <v-tooltip text="Remove time slot">
                <template v-slot:activator="{ props }">
                  <v-btn v-bind="props" color="error" variant="outlined" @click="removeTimeSlot(selectedTimeSlotIndex)">
                    <v-icon class="me-2">mdi-delete</v-icon>
                    Remove
                  </v-btn>
                </template>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card v-if="selectedTimeSlot && !selectedTimeSlot.isBreak" class="modern-card mb-4" elevation="2">
        <v-card-title class="card-header">
          <v-icon class="me-3" color="success">mdi-soccer</v-icon>
          Drills
        </v-card-title>
        <v-card-text class="pa-4">
          <v-container v-if="plan.team">
            <v-card
                v-for="(drill, drillIndex) in selectedTimeSlot.drills"
                :key="drill"
                class="drill-card mb-4"
                elevation="1"
            >
              <v-card-text class="pa-4">
                <v-row>
                  <v-col cols="12" md="11">
                    <v-row>
                      <v-col cols="12" md="7">
                        <v-text-field
                            label="Drill Name"
                            v-model="drill.name"
                            variant="outlined"
                            density="comfortable"
                            class="mb-3"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-select
                            clearable
                            chips
                            label="Groups"
                            v-model="drill.groups"
                            :items="plan.team.groups"
                            multiple
                            variant="outlined"
                            density="comfortable"
                            class="mb-3"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                            label="Notes"
                            auto-grow
                            density="comfortable"
                            rows="2"
                            v-model="drill.notes"
                            variant="outlined"
                            class="mb-3"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row v-if="drill.images && drill.images.length > 0">
                      <v-col cols="12">
                        <h4 class="text-h6 mb-3">
                          <v-icon class="me-2" color="info">mdi-image</v-icon>
                          Images
                        </h4>
                        <v-row>
                          <v-col cols="12" sm="4" v-for="(image, imageIndex) in drill.images" :key="image">
                            <v-card class="image-card" elevation="1">
                              <ImageDisplay :teamId="plan.team.id" :fileName="image"></ImageDisplay>
                              <v-card-actions class="pa-2">
                                <v-btn
                                    @click="removeDrillImage(selectedTimeSlotIndex, drillIndex, imageIndex)"
                                    color="error"
                                    variant="outlined"
                                    size="small"
                                >
                                  <v-icon size="small">mdi-delete</v-icon>
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row v-if="drill.links && drill.links.length > 0">
                      <v-col cols="12">
                        <h4 class="text-h6 mb-3">
                          <v-icon class="me-2" color="info">mdi-link</v-icon>
                          Links
                        </h4>
                        <v-card v-for="(link, linkIndex) in drill.links" :key="link" class="link-card mb-3"
                                elevation="1">
                          <v-card-text class="pa-3">
                            <v-row>
                              <v-col cols="12" sm="4">
                                <v-text-field label="Title" v-model="link.title" variant="outlined"
                                              density="comfortable"></v-text-field>
                              </v-col>
                              <v-col cols="10" sm="7">
                                <v-text-field label="URL" v-model="link.url" variant="outlined"
                                              density="comfortable"></v-text-field>
                              </v-col>
                              <v-col cols="2" sm="1">
                                <v-btn
                                    @click="removeLink(selectedTimeSlotIndex, drillIndex, linkIndex)"
                                    color="error"
                                    variant="outlined"
                                    size="small"
                                >
                                  <v-icon size="small">mdi-delete</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <div class="d-flex gap-2">
                          <v-tooltip text="Add Image">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                  v-bind="props"
                                  color="info"
                                  variant="outlined"
                                  v-if="plan.team.id"
                                  @click="showImageAddDialog(selectedTimeSlotIndex, drillIndex)"
                              >
                                <v-icon class="me-2">mdi-image-plus</v-icon>
                                Add Image
                              </v-btn>
                            </template>
                          </v-tooltip>
                          <v-tooltip text="Add Link">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                  v-bind="props"
                                  color="info"
                                  variant="outlined"
                                  @click="addLink(selectedTimeSlotIndex, drillIndex)"
                              >
                                <v-icon class="me-2">mdi-link-variant</v-icon>
                                Add Link
                              </v-btn>
                            </template>
                          </v-tooltip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="1">
                    <div class="d-flex flex-column gap-2">
                      <v-tooltip text="Remove drill">
                        <template v-slot:activator="{ props }">
                          <v-btn
                              v-bind="props"
                              color="error"
                              variant="outlined"
                              size="small"
                              class="action-btn"
                              @click="removeDrill(selectedTimeSlotIndex, drillIndex)"
                          >
                            <v-icon size="small">mdi-delete</v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>
                      <v-tooltip text="Save to Drill Library">
                        <template v-slot:activator="{ props }">
                          <v-btn
                              v-bind="props"
                              color="success"
                              variant="outlined"
                              size="small"
                              class="action-btn"
                              @click="saveToDrillLibrary(drill)"
                          >
                            <v-icon size="small">mdi-content-save-plus</v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card v-if="selectedTimeSlot.isBreak" class="break-card mb-4" elevation="1">
              <v-card-text class="pa-4 text-center">
                <v-icon size="48" color="indigo" class="mb-3">mdi-cup-water</v-icon>
                <h3 class="text-h6 text-indigo">Water Break</h3>
                <p class="text-body-2 text-medium-emphasis">Time for players to hydrate and rest</p>
              </v-card-text>
            </v-card>

            <v-row v-if="!selectedTimeSlot.isBreak">
              <v-col cols="12" md="6">
                <v-btn
                    color="primary"
                    variant="elevated"
                    @click="addDrill(selectedTimeSlotIndex)"
                    class="modern-btn"
                    style="width:100%"
                >
                  <v-icon class="me-2">mdi-plus</v-icon>
                  Add Drill
                </v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-btn
                    color="primary"
                    variant="outlined"
                    @click="showDrillLibrary(selectedTimeSlotIndex)"
                    class="modern-btn"
                    style="width:100%"
                >
                  <v-icon class="me-2">mdi-library</v-icon>
                  Add From Library
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
        v-model="libraryDialog"
        width="auto"
        min-width="300px"
        height="90vh"
        :fullscreen="this.$vuetify.display.mobile"
        scrollable
    >
      <v-card style=" display: flex; align-items: stretch">
        <v-container>
          <v-row class="selected-drill" style="height:80vh">
            <v-col cols="4" sm="4">
              <DrillLibraryTree :team="this.plan.team" @drillSelected="selectDrill"/>
            </v-col>
            <v-col cols="8" sm="8" style="overflow: scroll; height:80vh;" v-if="selectedLibraryDrill">
              <DrillView :drill=selectedLibraryDrill :teamId="plan.team.id" :showImages="true"
                         style=" overflow: scroll"></DrillView>
            </v-col>
          </v-row>

        </v-container>
        <v-card-actions>
          <v-btn color="primary" @click="addLibraryDrill" v-if="selectedLibraryDrill">Add Drill</v-btn>
          <v-btn color="" @click="libraryDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showImageAdd"
        width="auto"
        min-width="300"
        :fullscreen="this.$vuetify.display.mobile"
    >
      <FileUpload v-if="showImageAdd" @uploadComplete="imageUploadComplete" :teamId=plan.team.id></FileUpload>
    </v-dialog>
  </v-main>

</template>

<script>
import TimeDisplay from '../components/TimeDisplay.vue'
import ImageDisplay from '../components/ImageDisplay.vue'
import DrillListSummary from '../components/DrillListSummary.vue'
import FileUpload from '../components/FileUpload.vue'
import {computed, nextTick, ref} from "vue";
import api from '../../api'
import DrillView from "@/components/practiceplan/DrillView.vue";

import DrillLibraryTree from "../components/DrillLibraryTree.vue";

import {useDisplay} from 'vuetify'

var startTime = new Date();
startTime.setHours(18);
startTime.setMinutes(0);
startTime.setSeconds(0)

const newPlan = {
  "id": "new",
  "name": "",
  "date": ref(startTime),
  "team": {name: ""},
  "location": "",
  "notes": "",
  "timeSlots": [],
}

export default {
  name: 'PracticePlan',
  components: {
    DrillView,
    TimeDisplay,
    FileUpload,
    DrillListSummary,
    DrillLibraryTree,
    ImageDisplay,
  },
  created() {
    this.showSummaryNav = !useDisplay().value;
    this.showMobileNav = !useDisplay().value;

    // watch the params of the route to fetch the data again
    this.$watch(
        () => this.$route.params,
        () => {
          this.fetchPlan(this.$route.params.id);
        },
        // fetch the data when the view is created and the data is
        // already being observed
        {immediate: true}
    )

    this.$watch(
        () => this.plan.date,
        () => {
          this.dateChanged(this.$route.params.id);
        },
        // fetch the data when the view is created and the data is
        // already being observed
        {immediate: true}
    )
    this.$watch(
        () => this.libraryFilter,
        () => {
          console.log("filter update " + this.libraryFilter)
          let newFilterList = [];

          let filter = this.libraryFilter;

          this.libraryDrills.forEach((drill) => {
            if ((drill.name && drill.name.indexOf(filter) > -1) || (drill.notes && drill.notes.indexOf(filter) > -1)) {
              newFilterList.push(drill);
            }
          })

          this.filteredLibraryDrills = newFilterList;
        },
        // fetch the data when the view is created and the data is
        // already being observed
        {immediate: true}
    )

    this.$watch(
        () => this.plan.team.id,
        () => {
          if (this.plan && this.plan.team) {
            api.drills.listForTeam(this.plan.team.id, (drills) => {
              this.libraryDrills = drills;
              this.filteredLibraryDrills = drills;
            })
          }
        },
        // fetch the data when the view is created and the data is
        // already being observed
        {immediate: true}
    )
  },
  watch: {
    plan: {
      handler() {
        if (this.plan.timeSlots) {
          this.summary = {};

          let totalTime = 0;
          let drillTime = 0;
          let breakTime = 0;

          this.plan.timeSlots.forEach((slot) => {
            totalTime = totalTime + slot.duration;

            if (slot.isBreak) {
              breakTime = breakTime + slot.duration;
            } else {
              drillTime = drillTime + slot.duration;
            }
          });

          this.summary["Total Time"] = totalTime;
          this.summary["Drill Time"] = drillTime;
          this.summary["Break Time"] = breakTime;
        }
      },
      deep: true
    }
  },
  methods: {
    onDrop(evt) {
      // Remove item from old index
      const item = this.plan.timeSlots.splice(evt.oldIndex, 1)[0];

      nextTick(() => {
        // Insert it at new index
        this.plan.timeSlots.splice(evt.newIndex, 0, item);
      })

    },
    dateChanged() {
      const titlePrefix = "Practice "


      if (this.plan.date && this.plan.date.toDateString && (this.plan.name == "" || (this.plan.name.indexOf(titlePrefix) === 0 && this.plan.name.length > titlePrefix.length))) {
        this.plan.name = titlePrefix + this.plan.date.toDateString();
      }
    },
    deletePracticePlan() {

    },
    fetchPlan(id) {
      this.error = null;
      this.loadingPlans = true;

      api.me.get((me, err) => {
        this.loadingTeams = false
        if (err) {
          this.error = err.toString()
        } else {
          this.teams = me.teams

          if (!id || id === "undefined" || id === "new") {
            this.plan = newPlan;

            if (me.teams.length === 1) {
              this.plan.team = me.teams[0];
            }

            this.loadingPlans = false;
          } else {
            api.practicePlans.get(id, (plan) => {
              this.plan = plan;
              this.startTime = new Date(plan.date).getHours();
              this.loadingPlans = false;

              let teamId = plan.team.id;
              me.teams.forEach((t) => {
                if (t.id == teamId) {
                  this.plan.team.groups = t.groups || [];
                }
              });

              this.plan.timeSlots.forEach((t) => {
                t.drills.forEach((d) => {
                  if (!d.groups) {
                    d.groups = [];
                  }
                });
              })

            })
          }

        }
      })

    },
    dismissError: function () {
      this.errorMessage = null;
    },
    cancel: () => {
      this.plan = null;
      this.$router.push("/");
    },
    selectTimeslot(timeslot, timeSlotIndex) {
      this.selectedTimeSlot = timeslot;
      this.selectedTimeSlotIndex = timeSlotIndex;
    },

    selectDrill(drill) {
      this.selectedLibraryDrill = drill;
    },
    save: function () {

      this.plan.timeSlots.forEach((t) => {
        t.duration = parseInt(t.duration)
      })

      api.practicePlans.save(this.plan.team.id, this.plan, (savedPlan) => {
        console.log(this.$router)
        this.$router.push({name: 'planview', params: {id: savedPlan.id}})
      }, () => {
        this.errorMessage = "Unable to save plan"
      });
    },
    moveTimeSlotDown(index) {

      if (index === this.plan.timeSlots.length - 1) { // if its the last in the array
        this.timeSlots.unshift(this.timeSlots.pop()) // same as option 1
      } else {
        this.plan.timeSlots = this.plan.timeSlots.map((element, i) => { // iterate array and change places
          if (i === index) {
            return this.plan.timeSlots[index + 1];
          } else if (i === index + 1) {
            return this.plan.timeSlots[index];
          } else {
            return element;
          }
        })
        this.selectedTimeSlotIndex++;
      }
    },
    moveTimeSlotUp(index) {
      if (index === 0) { // if its the first in the array
        this.plan.timeSlots.push(this.plan.timeSlots.shift()) // same as option 1
      } else {
        this.plan.timeSlots = this.plan.timeSlots.map((element, i) => { // iterate array and change places
          if (i === index - 1) {
            return this.plan.timeSlots[index];
          } else if (i === index) {
            return this.plan.timeSlots[index - 1];
          } else {
            return element;
          }
        })

        this.selectedTimeSlotIndex--;
      }
    },
    removeTimeSlot(index) {
      this.plan.timeSlots.splice(index, 1);

      this.selectedTimeSlot = null;
    },
    addTimeSlot() {

      var newItem = {
        "duration": 15,

        "drills": [
          {
            "name": "",
            "notes": "",
            "links": [],
            "groups": []
          }
        ]
      };


      var insertIndex = this.selectedTimeSlotIndex;

      if (insertIndex < 0) {
        insertIndex = this.plan.timeSlots.length - 1;
      }

      this.plan.timeSlots.splice(insertIndex + 1, 0, newItem);

      this.selectTimeslot(newItem, insertIndex + 1)

    },
    addWaterBreak() {
      console.log(this.selectedTimeSlotIndex);
      var insertIndex = this.selectedTimeSlotIndex;

      if (insertIndex < 0) {
        insertIndex = this.plan.timeSlots.length - 1;
      }

      this.plan.timeSlots.splice(insertIndex + 1, 0, {
        "duration": this.plan.team.waterBreakLength || 5,
        "isBreak": true,
        "name": "Water Break"
      })

    },


    moveDrillDown(timeSlotIndex, drillIndex) {

      if (drillIndex === this.plan.timeSlots[timeSlotIndex].drills.length - 1) {
        return
      } else {
        this.plan.timeSlots[timeSlotIndex].drills = this.plan.timeSlots[timeSlotIndex].drills.map((element, i) => { // iterate array and change places
          if (i === drillIndex) {
            return this.plan.timeSlots[timeSlotIndex].drills[drillIndex + 1];
          } else if (i === drillIndex + 1) {
            return this.plan.timeSlots[timeSlotIndex].drills[drillIndex];
          } else {
            return element;
          }
        })
      }
    },
    moveDrillUp(timeSlotIndex, drillIndex) {
      if (drillIndex === 0) {
        return
      } else {
        this.plan.timeSlots[timeSlotIndex].drills = this.plan.timeSlots[timeSlotIndex].drills.map((element, i) => { // iterate array and change places
          if (i === drillIndex - 1) {
            return this.plan.timeSlots[timeSlotIndex].drills[drillIndex];
          } else if (i === drillIndex) {
            return this.plan.timeSlots[timeSlotIndex].drills[drillIndex - 1];
          } else {
            return element;
          }
        })
      }
    },
    removeDrill(timeSlotIndex, drillIndex) {
      this.plan.timeSlots[timeSlotIndex].drills.splice(drillIndex, 1);

    },
    removeDrillImage(timeSlotIndex, drillIndex, imageIndex) {
      this.plan.timeSlots[timeSlotIndex].drills[drillIndex].images.splice(imageIndex, 1);
    },
    addDrill(timeSlotIndex) {
      if (!this.plan.timeSlots[timeSlotIndex].drills) {
        this.plan.timeSlots[timeSlotIndex].drills = [];
      }
      this.plan.timeSlots[timeSlotIndex].drills.push({
        "name": "",
        "description": "",
        "notes": "",
        "links": [],
        "groups": []
      })

    },

    showDrillLibrary(timeSlotIndex) {
      this.selectedLibraryDrill = null;
      this.libraryDialog = true
    },
    addLibraryDrill() {
      if (!this.plan.timeSlots[this.selectedTimeSlotIndex].drills) {
        this.plan.timeSlots[this.selectedTimeSlotIndex].drills = [];
      }

      let copy = JSON.parse(JSON.stringify(this.selectedLibraryDrill))

      if (this.plan.timeSlots[this.selectedTimeSlotIndex].drills.length === 1) {
        let firstDrill = this.plan.timeSlots[this.selectedTimeSlotIndex].drills[0];

        if (firstDrill.notes.length === 0 &&
            firstDrill.name.length === 0 &&
            (!firstDrill.groups || firstDrill.groups.length === 0) &&
            (!firstDrill.links || firstDrill.links.length === 0) &&
            (!firstDrill.images || firstDrill.images.length === 0)) {

          this.plan.timeSlots[this.selectedTimeSlotIndex].drills.pop();
        }
      }
      this.plan.timeSlots[this.selectedTimeSlotIndex].drills.push(copy);
      this.libraryDialog = false;
    },
    saveToDrillLibrary(drill) {
      api.drills.save(this.plan.team.id, drill, () => {
        this.$toast.open({message: 'Drill saved', type: 'success'});
        this.loadDrills();
      }), () => {
        this.$toast.open({message: 'Unable to save drill', type: 'error'});
      }
    },
    showImageAddDialog(timeSlotIndex, drillIndex) {
      this.showImageAdd = true
      this.addImageToDrill = drillIndex;
      this.addImageToTimeSlot = timeSlotIndex;
    },
    addLink(timeSlotIndex, drillIndex) {
      if (!this.plan.timeSlots[timeSlotIndex].drills[drillIndex].links) {
        this.plan.timeSlots[timeSlotIndex].drills[drillIndex].links = [];
      }

      this.plan.timeSlots[timeSlotIndex].drills[drillIndex].links.push({
        title: "",
        url: "",
      })
    },

    removeLink(timeSlotIndex, drillIndex, linkIndex) {
      this.plan.timeSlots[timeSlotIndex].drills[drillIndex].links.splice(linkIndex, 1);
    },

    imageUploadComplete(id) {
      console.log("upload complete: " + id)
      this.showImageAdd = false;

      if (!this.plan.timeSlots[this.addImageToTimeSlot].drills[this.addImageToDrill].images) {
        this.plan.timeSlots[this.addImageToTimeSlot].drills[this.addImageToDrill].images = []
      }

      this.plan.timeSlots[this.addImageToTimeSlot].drills[this.addImageToDrill].images.push(id);
    },
  },
  data() {
    return {
      loadingPlans: false,
      teams: [],
      plan: {
        team: {}
      },
      errorMessage: null,
      libraryDialog: false,
      libraryFilter: "",
      libraryDrills: [],
      selectedTimeSlot: null,
      selectedTimeSlotIndex: -1,
      filteredLibraryDrills: [],
      selectedLibraryDrill: null,
      showImageAdd: false,
      addImageToDrill: 0,
      addImageToTimeSlot: 0,
      showMobileNav: true,
      showSummaryNav: true,
      expanded: [],
      summary: {
        "Total Time": 19,
        "Drill Time": 19,
        "Break Time": 19,
      },
      timeRules: ref({
        // minutes: {interval: 15},
        minutes: [0, 15, 30, 45],
      })
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Modern card styling */
.modern-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.modern-card:hover {
  transform: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.card-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  font-weight: 600;
  padding: 20px 24px;
}

/* Modern drawer styling */
.modern-drawer {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

/* Button styling */
.modern-btn {
  border-radius: 0px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0.5px !important;
  transition: all 0.2s ease;
}

/* All buttons in this component */
.v-btn {
  border-radius: 0px !important;
}

.modern-btn:hover {
  transform: none;
}

/* Time slot styling */
.time-slot-list {
  background: transparent;
}

.time-slot-item {
  border-radius: 12px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.time-slot-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
  transform: translateX(4px);
}

.break-slot {
  background-color: rgba(63, 81, 181, 0.1);
  border-left: 4px solid #3f51b5;
}

.selected-slot {
  background-color: rgba(25, 118, 210, 0.1);
  border-left: 4px solid #1976d2;
}

/* Drill card styling */
.drill-card {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
}

.drill-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

/* Image and link card styling */
.image-card,
.link-card {
  border-radius: 8px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

/* Break card styling */
.break-card {
  border-radius: 12px !important;
  background: linear-gradient(135deg, rgba(63, 81, 181, 0.1) 0%, rgba(63, 81, 181, 0.05) 100%);
  border: 1px solid rgba(63, 81, 181, 0.2);
}

/* Summary table styling */
.summary-table {
  background: transparent;
}

.summary-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.summary-label {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
}

.summary-value {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
}

/* Mobile view styling */
.mobile-view {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;
}

.time-slot-selector {
  border-radius: 12px !important;
  text-align: left !important;
  justify-content: flex-start !important;
}

.time-slot-menu {
  border-radius: 12px !important;
  max-height: 400px;
  overflow-y: auto;
}

.time-slot-menu-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.2s ease;
}

.time-slot-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Main content styling */
.practice-main {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;
}

/* Banner styling */
.modern-banner {
  border-radius: 12px !important;
}

/* Avatar styling */
.v-avatar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Progress bar styling */
.v-progress-linear {
  border-radius: 2px !important;
}

/* Text field styling */
.v-text-field .v-field {
  border-radius: 0px !important;
}

/* Select styling */
.v-select .v-field {
  border-radius: 0px !important;
}

/* Textarea styling */
.v-textarea .v-field {
  border-radius: 0px !important;
}

/* Chip styling */
.v-chip {
  border-radius: 8px !important;
  font-weight: 500 !important;
}

/* Action button styling */
.action-btn {
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 0px !important;
  padding: 0 !important;
}

.action-btn .v-icon {
  font-size: 18px !important;
}

/* Compact sidebar styling */
.card-header-compact {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  font-weight: 600;
  padding: 12px 16px;
  font-size: 0.9rem;
}

.summary-table-compact {
  background: transparent;
  font-size: 0.85rem;
}

.summary-row-compact {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  height: 32px;
}

.summary-label-compact {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  font-size: 0.8rem;
  padding: 4px 8px;
}

.summary-value-compact {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
  font-size: 0.8rem;
  padding: 4px 8px;
  text-align: right;
}

.compact-picker {
  font-size: 0.85rem;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .modern-card {
    margin-bottom: 16px;
  }

  .card-header {
    padding: 16px 20px;
  }

  .drill-card {
    margin-bottom: 16px;
  }
}

/* Animation for list items */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.time-slot-item,
.drill-card {
  animation: slideIn 0.3s ease-out;
}

/* Custom scrollbar for lists */
.v-list {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

  .v-list-item {
    min-height: 0px !important;
  }
}

.v-list::-webkit-scrollbar {
  width: 6px;
}

.v-list::-webkit-scrollbar-track {
  background: transparent;
}

.v-list::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.v-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

/* Legacy styles for compatibility */
.is-break {
  color: black;
}

.selected-drill {
  border-top: 1px solid rgb(128, 128, 128);
  min-height: 50vh;
  min-width: 50vw;
}

.link-list {
  list-style: none;
}
</style>
  